import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=3a7df0f4&scoped=true"
var script = {}
import style0 from "./Loader.vue?vue&type=style&index=0&id=3a7df0f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7df0f4",
  null
  
)

export default component.exports